import { useQuery } from '@apollo/client'
import { GET_CHATS, ChatsFilterRequest, GetChatsResponse } from '../queries'

interface UseGetChatsResult {
  data: GetChatsResponse | null
  loading: boolean
  error: Error | undefined
}

const DEFAULT_FILTERS: ChatsFilterRequest = {
  limit: 30,
  offset: 0,
}

export const useGetChats = (
  filters: ChatsFilterRequest = DEFAULT_FILTERS
): UseGetChatsResult => {
  const { data, loading, error } = useQuery<GetChatsResponse>(GET_CHATS, {
    variables: { filters },
    fetchPolicy: 'cache-and-network',
  })

  return {
    data: data || null,
    loading,
    error,
  }
}
